import { usePartnerConfig } from '~/stores/usePartnerConfig';
import { LandingType } from '~/enums/LandingType';

export default defineNuxtRouteMiddleware((to, from) => {
  const { landing } = usePartnerConfig();

  const hasBlackProxyComponent = computed(() => {
    switch (landing.value) {
      case LandingType.SX:
        return false;
      case LandingType.BLACKPROXY:
        return true;
      case LandingType.NEXUS:
        return false;
      case LandingType.ANYPAGE:
        return false;
      case LandingType.AKENET:
        return false;
      case LandingType.ASOCKS:
        return false;
      default:
        return false;
    }
  })

  if (!hasBlackProxyComponent.value) {
    return navigateTo('/')
  }
})